.overlay {
  position: fixed;
  display: flex;
  flex: 1;
  top: 0;
  min-height: 100vh;
  max-height: 100vh;
  min-width: 100%;
  max-height: 100%;
  justify-content: center;
  align-items: center;
  inset: 0px;
  background-color: rgba(0, 0, 0, 0.75);
  opacity: 0;
  transition: opacity 350ms ease-in-out;
  overflow: auto;
  z-index: 5;
}

.overlayAfterOpen {
  opacity: 1;
}

.overlayBeforeClose {
  opacity: 0;
}

.container {
  position: absolute;
  top: 0;
  left: 50%;
  background: var(--white);
  overflow: auto;
  border-radius: 12px;
  border: none;
  outline: none;
  padding: 0;
  opacity: 0;
  transform: translate(-50%, 0);
  transition: all 350ms ease-in-out;
  min-width: 350px;
  min-height: 150px;
}

.containerAfterOpen {
  opacity: 1;
  top: 50%;
  transform: translate(-50%, -50%);
}

.containerBeforeClose {
  opacity: 0;
  top: 0;
  transform: translate(-50%, 0);
}

.header {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 1.5rem;
  font-family: 'Syne';
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--white);
  background: linear-gradient(90deg, var(--header-gradient1) 0%, var(--header-gradient2) 98.49%);
}

.content {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  font-family: 'Aeroport';
  font-size: .8rem;
  font-weight: normal;
}

.footer {
  display: flex;
  align-items: center;
  height: 84px;
}
